import { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
// Pages
import HomePage from 'pages/HomePage';
import OfficePage from 'pages/OfficePage';
import PrivacyPolicyPage from 'pages/PrivacyPolicy';
import TermsOfServicePage from 'pages/TermsOfService';

const AppRouting:FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/office" element={<OfficePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-of-service" element={<TermsOfServicePage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  )
}

export default AppRouting;
